module.exports = __webpack_public_path__ + "static/ibm-plex-serif-v8-latin-regular-0cc912a170859fab2c53384e0944d19e.woff";